import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-mars1-debate-opinion-row',
  templateUrl: './mars1-debate-opinion-row.component.html',
  styleUrls: ['./mars1-debate-opinion-row.component.scss']
})
export class Mars1DebateOpinionRowComponent implements OnInit {
  @Input() opinion: any;
  public voteColour: string;
  public voteIcon: string;
  public voteLabel: string;

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    if (!this.opinion.vote) {
      this.voteColour = '';
      this.voteIcon = '';
      this.voteLabel = '--';
      return;
    }

    const isPositiveVote = this.opinion.vote === 'positive';
    this.voteColour = isPositiveVote ? 'green-text' : 'red-text';
    this.voteIcon = isPositiveVote ? 'thumb-up' : 'thumb-down';
    this.voteLabel = isPositiveVote
      ? this.translate.instant('debates.positiveVote')
      : this.translate.instant('debates.negativeVote');
  }
}
